export const Url = {
    baseurl: "https://6xo4h2bpwj.execute-api.ap-south-1.amazonaws.com/Prod/",
    Apiurl: 'https://uy3mldqugd.execute-api.ap-south-1.amazonaws.com/Prod/',
} 